import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  ActionDirective,
  PageClickStrategy
} from '@element451-libs/page451-lib';
import { EditorRowsProxy } from '@element451-libs/page451-rows';
import { URL_REGEXP } from '@element451-libs/utils451/validators';

function isFragment(href: string) {
  return href && href.charAt(0) === '#';
}

const isUrl = new RegExp(URL_REGEXP, ''); // override any flags

function isExternalUrl(href: string) {
  return isUrl.test(href);
}

const isFormGuid = /.*\.forms\..*/;

function isFormsDialog(href: string) {
  return isFormGuid.test(href);
}

@Injectable()
export class AppClientClickStrategy extends PageClickStrategy {
  constructor(
    private router: Router,
    private proxy: EditorRowsProxy
  ) {
    super();
  }

  click(action: ActionDirective) {
    if (isFragment(action.href)) {
      this.router.navigate([], { fragment: action.href.substring(1) });

      // clear the fragment so subsequent updates can be detected
      Promise.resolve(null).then(() =>
        this.router.navigate([], { fragment: '' })
      );
    } else if (isExternalUrl(action.href)) {
      const url = decodeURIComponent(action.href);
      window.open(url, '_blank');
    } else if (isFormsDialog(action.href)) {
      this.proxy.handleOpenFormDialogClick(action.href);
    }
  }
}
